import { AbstractControl, ValidationErrors } from '@angular/forms';

const ODD_MAP: Record<string, number> = {
  '0': 1, '1': 0, '2': 5, '3': 7, '4': 9, '5': 13, '6': 15, '7': 17, '8': 19, '9': 21,
  A: 1, B: 0, C: 5, D: 7, E: 9, F: 13, G: 15, H: 17, I: 19, J: 21,
  K: 2, L: 4, M: 18, N: 20, O: 11, P: 3, Q: 6, R: 8, S: 12, T: 14,
  U: 16, V: 10, W: 22, X: 25, Y: 24, Z: 23,
};

const EVEN_MAP: Record<string, number> = {
  '0': 0, '1': 1, '2': 2, '3': 3, '4': 4, '5': 5, '6': 6, '7': 7, '8': 8, '9': 9,
  A: 0, B: 1, C: 2, D: 3, E: 4, F: 5, G: 6, H: 7, I: 8, J: 9,
  K: 10, L: 11, M: 12, N: 13, O: 14, P: 15, Q: 16, R: 17, S: 18, T: 19,
  U: 20, V: 21, W: 22, X: 23, Y: 24, Z: 25,
};

const ALPHABET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';

function calculateCfControlChar(cf15: string): string {
  let total = 0;
  for (let i = 0; i < cf15.length; i++) {
    total += (i + 1) % 2 !== 0 ? ODD_MAP[cf15[i]] : EVEN_MAP[cf15[i]];
  }
  return ALPHABET[total % 26];
}

function isValidCodiceFiscale(cf: string): boolean {
  if (!cf || cf.length !== 16) return false;
  const upper = cf.toUpperCase();
  const expected = calculateCfControlChar(upper.slice(0, 15));
  return expected === upper[15];
}

const CF_PATTERN =
  /^[a-zA-Z]{6}[0-9LMNPQRSTUVlmnpqrstuv]{2}[A-EHLMPR-Ta-ehlmpr-t][0-9LMNPQRSTUVlmnpqrstuv]{2}[a-zA-Z][0-9LMNPQRSTUVlmnpqrstuv]{3}[a-zA-Z]$/;

const PIVA_PATTERN = /^[0-9]{11}$/;

export function TaxIdCodeValidator(
  control: AbstractControl,
): ValidationErrors | null {
  const value = (control.value || '').trim();

  if (!value) return null;

  if (PIVA_PATTERN.test(value)) return null;

  if (CF_PATTERN.test(value) && isValidCodiceFiscale(value)) return null;

  return { taxIdCode: true };
}
